import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import {
  STREAM_EVENT_API_URL,
  STREAM_EVENT_BY_TOKEN_QUERY_KEY,
  STREAM_EVENT_BY_TOKEN_QUERY_KEY_TWO
} from '@/constants';
import { apiUrl } from '@/helpers';
import { ErrorResponse, Options } from '@/types';

export const streamEndpoints = {
  getStreamEvent: (token: string) => axios.get(`${apiUrl()}${STREAM_EVENT_API_URL}/token/${token}`),
  getStreamEventStatus: (token: string) =>
    axios.get(`${apiUrl()}${STREAM_EVENT_API_URL}/status/${token}`)
};

export const useGetStreamEventByToken = (token: string, options?: Options) => {
  return useQuery(
    [STREAM_EVENT_BY_TOKEN_QUERY_KEY, { token }],
    () => streamEndpoints.getStreamEvent(token),
    {
      enabled: !!token,
      onError: (error) => {
        options?.onError(error as ErrorResponse);
      }
    }
  );
};

export const useGetStreamEventStatus = (token: string, options?: Options) => {
  return useQuery(
    [STREAM_EVENT_BY_TOKEN_QUERY_KEY_TWO, { token }],
    () => streamEndpoints.getStreamEventStatus(token),
    {
      enabled: !!token,
      onError: (error) => {
        options?.onError(error as ErrorResponse);
      }
    }
  );
};
